import { NgModule }                                         from '@angular/core';
import { BrowserModule }                                    from '@angular/platform-browser';
import { LocationStrategy, HashLocationStrategy }           from '@angular/common';
import { AppComponent }                                     from './app.component';
import { TabsModule }                                       from 'ng2-bootstrap/tabs';
import { HttpModule }    	                                  from '@angular/http';
import { ChartsModule }                                     from 'ng2-charts/ng2-charts';
import { SIDEBAR_TOGGLE_DIRECTIVES }                        from './shared/sidebar.directive';
import { AsideToggleDirective }                             from './shared/aside.directive';
import { BreadcrumbsComponent }                             from './shared/breadcrumb.component';
import { AppRoutingModule }                                 from './app.routing';
import { FullLayoutComponent }                              from './layouts/full-layout.component';
import { BrowserAnimationsModule }                          from '@angular/platform-browser/animations';
import { MdButtonModule, MdSelectModule }                   from '@angular/material';
import { UserModule }                                       from './users/user.module';
import { environment }                                      from '../environments/environment';
import { AngularFireModule }                                from 'angularfire2';
import { AngularFireDatabaseModule }                        from 'angularfire2/database';
import { AngularFireAuthModule }                            from 'angularfire2/auth';
import { AuthService }                                      from "./providers/auth.service";


@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    TabsModule.forRoot(),
    UserModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    ChartsModule,
    HttpModule,
    BrowserAnimationsModule,
    BrowserModule,
    MdSelectModule
  ],

  declarations: [
    AppComponent,
    FullLayoutComponent,
    BreadcrumbsComponent,
    SIDEBAR_TOGGLE_DIRECTIVES,
    AsideToggleDirective
  ],
  providers: [
      AuthService,
    {
    provide: LocationStrategy,
    useClass: HashLocationStrategy
  }],
  bootstrap: [ AppComponent ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts